var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (integration, integrationActive, isClearbitReveal, isSegment, showConfigure, tenant, user) {
      pug_html = pug_html + "\u003Cdiv class=\"div\"\u003E\u003Cscript type=\"text\u002Ftemplate\" id=\"tpl_main\"\u003E\u003Cnav class=\"navbar navbar-expand-lg navbar-light bg-light box-shadow-3d\" aria-label=\"breadcrumb\"\u003E\u003Cul class=\"navbar-nav navbar-brand mr-auto mt-2 mt-lg-0\"\u003E\u003Cli class=\"breadcrumb-item\"\u003E\u003Ca class=\"breadcrumb-link text-primary\" id=\"go_back_integration_board\"\u003EIntegrations\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
if (integration === 'clearbit_reveal') {
pug_html = pug_html + "\u003Cli class=\"breadcrumb-item active text-capitalize\" aria-current=\"page\"\u003EAnonymous Visitor Identifier\u003C\u002Fli\u003E";
}
if (integration === 'job_changes') {
pug_html = pug_html + "\u003Cli class=\"breadcrumb-item active text-capitalize\" aria-current=\"page\"\u003EJob Changes\u003C\u002Fli\u003E";
}
else
if (integration === 'identification') {
pug_html = pug_html + "\u003Cli class=\"breadcrumb-item active text-capitalize\" aria-current=\"page\"\u003EAccount identification\u003C\u002Fli\u003E";
}
else
if (integration === 'tag') {
pug_html = pug_html + "\u003Cli class=\"breadcrumb-item active text-capitalize\" aria-current=\"page\"\u003EMadKudu Tag\u003C\u002Fli\u003E";
}
else {
pug_html = pug_html + "\u003Cli class=\"breadcrumb-item active text-capitalize\" aria-current=\"page\"\u003E" + (pug.escape(null == (pug_interp = integration) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003C\u002Ful\u003E\u003Cdiv class=\"my-2 my-lg-0\"\u003E";
if (integrationActive) {
pug_html = pug_html + "\u003Cbutton class=\"btn btn-success mx-1\" id=\"test_button\"\u003ETest connection\u003C\u002Fbutton\u003E";
}
if (showConfigure) {
pug_html = pug_html + "\u003Cbutton class=\"btn btn-primary mr-2\" id=\"configure_integration\"\u003EConfigure\u003C\u002Fbutton\u003E";
}
if (!isClearbitReveal) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes(["btn","btn-outline-primary","sku",user.superKudu ? 'visible' : 'd-none'], [false,false,false,true]), false, true)+" id=\"mki_admin\""+pug.attr("href", '/org/' + tenant + '/integrations/' + integration + '/admin', true, true)+" style=\"float: right;\"") + "\u003EAdmin\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E";
if (isSegment = true) {
pug_html = pug_html + "\u003Cdiv id=\"integration\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"container mt-4 pb-5\"\u003E\u003Cdiv class=\"card box-shadow-3d mx-2 p-2\"\u003E\u003Cdiv class=\"p-2\" id=\"integration\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fscript\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "integration" in locals_for_with ?
        locals_for_with.integration :
        typeof integration !== 'undefined' ? integration : undefined, "integrationActive" in locals_for_with ?
        locals_for_with.integrationActive :
        typeof integrationActive !== 'undefined' ? integrationActive : undefined, "isClearbitReveal" in locals_for_with ?
        locals_for_with.isClearbitReveal :
        typeof isClearbitReveal !== 'undefined' ? isClearbitReveal : undefined, "isSegment" in locals_for_with ?
        locals_for_with.isSegment :
        typeof isSegment !== 'undefined' ? isSegment : undefined, "showConfigure" in locals_for_with ?
        locals_for_with.showConfigure :
        typeof showConfigure !== 'undefined' ? showConfigure : undefined, "tenant" in locals_for_with ?
        locals_for_with.tenant :
        typeof tenant !== 'undefined' ? tenant : undefined, "user" in locals_for_with ?
        locals_for_with.user :
        typeof user !== 'undefined' ? user : undefined));
    ;;return pug_html;};
module.exports = template;